import { Card, Stack, Typography, useTheme } from '@mui/material';

import { BorderLinearProgress } from '@app/modules/employee-dashboard/styles';
import { IProject, ITaskOverview } from '@app/modules/dashboard';
import { Scrollbar } from '../scrollbar';
import { CustomAvatar } from '../custom-avatar';
import { DataNotFound } from '../page-404';

interface Props {
  projectData: ITaskOverview;
  title: string;
}

const ProjectContribution = ({ projectData, title }: Props) => {
  const theme = useTheme();

  return (
    <>
      <Typography variant="h6">{title}</Typography>
      {projectData?.projects?.length === 0 ? (
        <Stack height="100%" alignItems="center" justifyContent="center">
          <DataNotFound height={200} />
        </Stack>
      ) : (
        <Scrollbar sx={{ py: 2 }}>
          <Stack spacing={1}>
            {projectData?.projects?.map((project: IProject, index: number) => {
              const projectContribution = project?.totalTasks
                ? (project?.totalDoneTasks / project?.totalTasks) * 100
                : 0;

              return (
                <Card
                  key={index}
                  sx={{
                    width: '100%',
                    padding: 1,
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    borderRadius: '5px',
                  }}
                >
                  <CustomAvatar
                    src={project.image}
                    name={project.projectName}
                    color={project.image ? 'default' : 'info'}
                    sx={{
                      '& img': {
                        objectFit: 'contain',
                        width: '100%',
                        height: '100%',
                      },
                    }}
                  />
                  <Stack justifyContent="center" width="25%">
                    <Typography
                      variant="subtitle2"
                      sx={{
                        whiteSpace: 'normal',
                        overflowWrap: 'break-word',
                        wordBreak: 'break-word',
                      }}
                    >
                      {project?.projectName}
                    </Typography>
                  </Stack>
                  <BorderLinearProgress
                    variant="determinate"
                    value={projectContribution}
                    sx={{
                      width: '50%',
                      alignSelf: 'center',
                      '& .MuiLinearProgress-bar': {
                        backgroundColor: theme.palette.info.darker,
                      },
                    }}
                  />
                  <Stack sx={{ justifyContent: 'center' }}>
                    <Typography>
                      {`${
                        Number(projectContribution) % 1 === 0
                          ? Number(projectContribution)
                          : Number(projectContribution).toFixed(2)
                      }%`}
                    </Typography>
                  </Stack>
                </Card>
              );
            })}
          </Stack>
        </Scrollbar>
      )}
    </>
  );
};

export { ProjectContribution };
